import "./mailcheck.js";

var topLevelDomains = ["com", "net", "org", "se"];

window.fillField = function (event, id, suggestion) {
  var el = document.getElementById(id);
  if (el) el.value = suggestion;
  event.preventDefault();
  document.querySelectorAll(".suggestion").forEach(function (s) {
    s.remove();
  });
};

document.addEventListener("DOMContentLoaded", function () {
  var pageTitleInput = document.querySelector("input[name=_page_title]");
  if (pageTitleInput) pageTitleInput.value = document.title;

  document.querySelectorAll("input[name=email]").forEach(function (input) {
    input.addEventListener("blur", function () {
      var self = this;
      Mailcheck.run({
        email: self.value,
        topLevelDomains: topLevelDomains,
        suggested: function (suggestion) {
          document.querySelectorAll(".suggestion").forEach(function (s) {
            s.remove();
          });
          var div = document.createElement("div");
          div.className = "suggestion";
          div.innerHTML =
            'Menade du <strong><em><a href="#" onclick="window.fillField(event, \'' +
            self.id +
            "', '" +
            suggestion.full +
            "'); return false\">" +
            suggestion.full +
            "</a>?</em></strong></div>";
          self.parentNode.insertBefore(div, self.nextSibling);
        },
        empty: function () {
          document.querySelectorAll(".suggestion").forEach(function (s) {
            s.remove();
          });
        },
      });
    });
  });

  document.querySelectorAll(".form-modal__close").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.querySelectorAll(".form__modal-overlay").forEach(function (el) {
        el.classList.add("d-none");
      });
      document.querySelectorAll(".form__modal").forEach(function (el) {
        el.classList.add("d-none");
      });
    });
  });

  document.querySelectorAll(".moln8-form").forEach(function (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var token = form.querySelector(".token");
      var spinner = form.querySelector(".spinner");
      var submitBtn = form.querySelector("button[type=submit]");

      if (spinner) spinner.classList.toggle("d-none");
      if (submitBtn) submitBtn.disabled = true;

      fetch("/forms/preflight")
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (token) token.value = data.token;
          form.submit();
        })
        .catch(function () {
          if (spinner) spinner.classList.toggle("d-none");
          if (submitBtn) submitBtn.disabled = false;
          alert("Något gick snett när det skulle sparas!");
        });
    });
  });
});
